import React, { InputHTMLAttributes } from 'react'
import { classNames } from '../wrapper'
import { useNumberInput } from './useNumberInput'

const Number: React.FC<{
    value: number;
    change: (number: number) => void;
    children?: (attrs: InputHTMLAttributes<any>) => React.ReactNode
    fractionDigits?: number;
    error?: boolean;
    disabled?: boolean;
}> = (props) => {
    const { last, onChange, onBlur } = useNumberInput(props.value, props.change, props.fractionDigits)

    if (props.children) {
        return <>
            {props.children({
                value: last,
                onBlur: () => onBlur(),
                onInput: (e) => onChange((e.target as HTMLInputElement).value)
            })}
        </>
    }

    return <input type='number' className={classNames('input border',props.disabled ? 'bg-gray-200' : '', props.error ? 'border-error-300' : 'border-gray-300')} disabled={!!props.disabled} value={last} onBlur={() => onBlur()} onInput={(e) => onChange((e.target as HTMLInputElement).value)} />
}

export default Number
